// src/routes/PublicOnly.js
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

/** 로그인돼 있으면 /main 으로 보내고, 아니면 children 렌더 */
export default function PublicOnly({ children }) {
    const { userInfo } = useUser();
    return userInfo?.logged_in ? <Navigate to="/main" replace /> : children;
}